import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import get from 'lodash.get';

// components
import PdpRespBreadcrumbs from '../PdpRespBreadcrumbs/PdpRespBreadcrumbs';
import PdpSharedNotListedHeader from '../PdpSharedNotListedHeader/PdpSharedNotListedHeader';
import PdpRespSimilarItemsGrid from '../PdpRespSimilarItems/PdpRespSimilarItemsGrid';
import PdpRespSeoLinks from '../PdpRespSeoLinks/PdpRespSeoLinks';
import FollowSearchButton from '../../components/global/FollowSearchButton/FollowSearchButton';

import styles from './PdpRespContainerNotListed.scss';

export class PdpRespContainerNotListed extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            item,
            user,
            similarGridItems,
            relayVariables,
            viewer,
            currency,
            hasFetchedOnClient,
        } = this.props;

        return (
            <Fragment>
                {/* Breadcrumbs */}
                <PdpRespBreadcrumbs item={item} />

                {/* Title */}
                <PdpSharedNotListedHeader item={item} additionalStyles={styles} />

                {/* Follow Search Button */}
                <div className={styles.followButton}>
                    <FollowSearchButton
                        size="medium"
                        userId={get(user, 'serviceId')}
                        page={get(item, 'saveSearchData.page')}
                        favoritesConnection={get(user, 'favorites') || null}
                    />
                </div>

                {/* You May Also Like */}
                <div className={styles.similar}>
                    <PdpRespSimilarItemsGrid
                        relayVariables={{
                            userId: relayVariables.userId,
                            isClient: relayVariables.isClient,
                            fetchFavorites: relayVariables.fetchFavorites,
                        }}
                        item={item}
                        similarItems={similarGridItems}
                        isDark={false}
                        viewer={viewer}
                        currency={currency}
                        hasFetchedOnClient={hasFetchedOnClient}
                        user={user}
                    />
                </div>

                {/* More Ways To Browse */}
                <PdpRespSeoLinks viewer={viewer} item={item} />
            </Fragment>
        );
    }
}

PdpRespContainerNotListed.propTypes = {
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    viewer: PropTypes.object.isRequired,
    relayVariables: PropTypes.shape({
        fetchFavorites: PropTypes.bool,
        userId: PropTypes.string,
        isClient: PropTypes.bool.isRequired,
    }).isRequired,
    similarGridItems: PropTypes.object.isRequired,
    fetchFavorites: PropTypes.bool,
    currency: PropTypes.string,
    hasFetchedOnClient: PropTypes.bool,
};

export default createFragmentContainer(PdpRespContainerNotListed, {
    viewer: graphql`
        fragment PdpRespContainerNotListed_viewer on Viewer {
            ...PdpRespSimilarItemsGrid_viewer
            ...PdpRespSeoLinks_viewer
        }
    `,
    item: graphql`
        fragment PdpRespContainerNotListed_item on Item {
            ...PdpSharedNotListedHeader_item
            ...PdpRespBreadcrumbs_item
            ...PdpRespTitle_item
            ...PdpRespSeoLinks_item
            saveSearchData {
                page
            }
        }
    `,
    user: graphql`
        fragment PdpRespContainerNotListed_user on User {
            ...PdpRespSimilarItemsGrid_user
            serviceId
            favorites(first: 1, types: [SEARCH], pages: $favoritePages)
                @include(if: $fetchFavorites) {
                ...FollowSearchButton_favoritesConnection
            }
        }
    `,
    similarGridItems: graphql`
        fragment PdpRespContainerNotListed_similarGridItems on moreLikeThisConnection {
            ...PdpRespSimilarItemsGrid_similarItems
        }
    `,
});
